<template>
  <!-- shaxmatka container,  контейнер Сетки  -->
  <div
    ref="scroller"
    style="overflow-x: auto"
    class="selecto-container"
  >
    <!-- здесь начинается этажи, stages here -->
    <div
      v-for="(stage, index) in getShaxmatka"
      :key="index"
      style="gap: 40px"
      class="stage d-flex align-items-center mb-1 p-50"
      @mouseenter="stageHover(index)"
    >
      <span
        style="max-width: 100px; min-width: 100px"
        class="mr-1"
      >
        {{ stage.title }}
      </span>
      <!-- здесь начинается подъезды, sections here -->
      <div
        v-for="(section, sect_ind) in stage.section"
        :key="sect_ind"
        class="d-flex align-items-center h-100"
        :style="`min-width: calc(52px * ${section.get_max_flats}; gap: 15px`"
      >
        <!-- здесь начинается квартыры, flats here -->
        <b-button
          v-for="(flat, flat_ind) in section.flats"
          :id="flat.id"
          :key="flat.id"
          squared
          :disabled="filterFlats(flat)"
          :variant="flat.current_status ? flat.current_status.color : 'info'"
          class="selecto-target p-1"
          :style="btnStyles(flat, flat_ind)"
          @click="toggleSideBar(flat)"
        >
          <!-- :style="`width: calc(100% / ${section.flats.length}`" -->
          {{ flat.rooms_count }}
          <b-tooltip
            v-if="withTooltip"
            :target="String(flat.id)"
            custom-class="shadow"
            triggers="hover"
            no-fade
            variant="secondary"
            placement="top"
          >
            <div class="d-flex align-items-center justify-content-between">
              <b-badge pill>
                <!-- :variant="flat.status.color" -->
                {{ flat.rooms_count }}к
              </b-badge>
              <p class="text-weight=bold ml-1 mb-0">
                {{
                  flat.current_status === "secondary"
                    ? "Продано"
                    : $_moneyFormatter(flat.total_price)
                }}
              </p>
            </div>
            <div class="d-flex align-items-center justify-content-between">
              №{{ flat.flat_number }}
              <p
                style="white-space: nowrap"
                class="text-weight=bold ml-1 mb-0"
              >
                {{ flat.total_area.toFixed(2) }}м²
                {{
                  flat.current_status == "secondary"
                    ? ""
                    : " — " +
                      $_moneyFormatter(
                        (flat.total_price / flat.total_area).toFixed(2)
                      )
                }}
              </p>
            </div>
          </b-tooltip>
        </b-button>
      </div>
      <span class="ml-auto">
        {{ stage.title }}
      </span>
    </div>
    <vue-selecto
      v-if="!sidebar"
      ref="selectoVue"
      :selectable-targets="['.selecto-target']"
      :drag-container="dragContainer"
      :hit-rate="100"
      :select-from-inside="true"
      :select-by-click="true"
      :continue-select="true"
      :toggle-continue-select="['shift']"
      ratio="0"
      :scroll-options="scrollOptions"
      @dragStart="onDragStart"
      @select="onSelect"
      @selectEnd="selectoEnded"
      @scroll="onScroll"
    />
  </div>
  <!-- @dragStart="onDragStart"
      @keydown="onKeydown"
      @keyup="onKeyup"
      @selectStart="onSelectStart"
      @selectEnd="onSelectEnd" -->
</template>

<script>
import {
  BButton, VBToggle, BTooltip, BBadge,
} from 'bootstrap-vue'
import { VueSelecto } from 'vue-selecto'
import formatters from '@/mixins/extra'

export default {
  directives: {
    'b-toggle': VBToggle,
  },
  components: {
    VueSelecto,
    BButton,
    BTooltip,
    BBadge,
  },
  mixins: [formatters],
  props: {
    data: {
      type: Array,
      required: true,
    },
    initially_selected_elements: {
      type: Array,
      required: false,
      default() {
        return []
      },
    },
    withTooltip: {
      type: Boolean,
      required: false,
      default: false,
    },
    sidebar: {
      type: Boolean,
      required: false,
      default: false,
    },
    filter: {
      type: Object,
      required: false,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      dragContainer: document.querySelector('.selecto-container'),
      selected_elements: [],
      scrollOptions: {},
      selected_flat: null,
      sidebar_visibility: false,
    }
  },
  computed: {
    getShaxmatka() {
      const shaxmatka = []
      if (this.data) return this.data
      return shaxmatka
    },
  },
  watch: {
    selected_elements() {
      this.$emit('selectoEnd', this.selected_elements)
    },
  },
  mounted() {
    const list = window.document.querySelectorAll('.selecto-target')
    // const q = ['1', '2', '3']
    const initially_selected_flats = []
    list.forEach(e => {
      if (this.initially_selected_elements.includes(Number(e.id))) {
        e.classList.add('selected')
        initially_selected_flats.push(e)
      }
    })
    if (this.$refs.selectoVue) {
      this.$refs.selectoVue.setSelectedTargets(initially_selected_flats)
    }
    this.scrollOptions = {
      container: this.$refs.scroller,
      throttleTime: 30,
      threshold: 0,
    }
    // this.initially_selected_elements.forEach(element => {
    //   document.getElementById(element).classList.add('selected')
    // })
    this.selected_elements = this.initially_selected_elements
  },
  methods: {
    onDragStart(e) {
      if (e.inputEvent.target.nodeName === 'BUTTON') {
        return false
      }
      return true
    },
    onSelect(e) {
      e.added.forEach(el => {
        if (!this.selected_elements.includes(Number(el.id))) {
          this.selected_elements.push(Number(el.id))
        }
        el.classList.add('selected')
      })
      e.removed.forEach(el => {
        el.classList.remove('selected')
      })
    },
    selectoEnded(e) {
      const arr = []
      e.selected.forEach(el => {
        arr.push(Number(el.id))
      })
      this.selected_elements = arr
    },
    onScroll(e) {
      this.$refs.scroller.scrollBy(e.direction[0] * 10, e.direction[1] * 10)
    },

    stageHover() {},
    // onDragStart(e) {
    //   console.log('ds', e.inputEvent.target)
    // },
    onKeydown() {
      document.querySelector('.button').classList.add('selected')
    },
    onKeyup() {
      document.querySelector('.button').classList.remove('selected')
    },
    btnStyles(flat, index) {
      const position = flat.area_number
      let scale = 1
      let translate = 0

      if (
        this.selected_flat === flat.id
        || this.selected_elements.includes(Number(flat.id))
      ) {
        scale = 1.2
      }
      if (this.filterFlats(flat)) {
        scale = 0.7
      }

      if (position) {
        translate = (position - 1 - index) * (44 + 11)
      }

      return {
        transform: `translateX(${translate}px) scale(${scale})`,
      }
    },
    toggleSideBar(flat) {
      if (this.sidebar) {
        if (this.selected_flat === flat.id) {
          console.log('sidebar-active')
          this.selected_flat = null
        } else {
          this.selected_flat = flat.id
          this.sidebar_visibility = true
          this.$emit('flatSelected', flat)
        }
      }
    },
    checkForRoomsCount(flat) {
      if (
        this.filter.rooms_count_list.includes(flat.rooms_count)
        || this.filter.rooms_count_list.length === 0
      ) {
        return true
      }
      return false
    },
    checkForStatus(flat) {
      if (flat.current_status && this.filter.current_status.includes(flat.current_status.id)) {
        return true
      }
      return false
    },
    checkforTotalPrice(flat) {
      if (!this.filter.total_price_start && !this.filter.total_price_end) {
        return true
      }
      if (
        this.filter.total_price_start <= flat.total_price
        && !this.filter.total_price_end
      ) {
        return true
      }
      if (
        this.filter.total_price_end >= flat.total_price
        && !this.filter.total_price_start
      ) {
        return true
      }
      if (
        this.filter.total_price_start <= flat.total_price
        && this.filter.total_price_end >= flat.total_price
      ) {
        return true
      }
      return false
    },
    checkforTotalArea(flat) {
      if (!this.filter.total_area_start && !this.filter.total_area_end) {
        return true
      }
      if (
        this.filter.total_area_start <= flat.total_area
        && !this.filter.total_area_end
      ) {
        return true
      }
      if (
        this.filter.total_area_end >= flat.total_area
        && !this.filter.total_area_start
      ) {
        return true
      }
      if (
        this.filter.total_area_start <= flat.total_area
        && this.filter.total_area_end >= flat.total_area
      ) {
        return true
      }
      return false
    },
    filterFlats(flat) {
      if (this.sidebar && Object.keys(this.filter).length) {
        if (
          this.checkForRoomsCount(flat)
          && this.checkforTotalPrice(flat)
          && this.checkforTotalArea(flat)
          && this.checkForStatus(flat)
        ) {
          return false
        }
        return true
      }
      return false
    },
  },
}
</script>

<style>
html,
body,
.container {
  position: relative;
  height: 100%;
  margin: 0;
  padding: 0;
}
.target,
.target2 {
  position: absolute;
  background: #faa;
  box-sizing: border-box;
}
.target.selected {
  border: 4px solid #f55;
}
.button {
  position: absolute;
  left: 500px;
  top: 50px;
  background: #eee;
  padding: 15px 40px;
  display: inline-block;
  border-radius: 5px;
  font-weight: bold;
  color: #444;
}
.selected {
  /* transform: scale(1.2, 1.2) !important; */
}
.deselected {
  transform: scale(0.7, 0.7) !important;
}
.selecto-target {
  width: 40px;
}
.selecto-container div.stage:nth-child(odd) {
  background: #e0e0e0;
}

.selecto-container div.stage:nth-child(even) {
  background: #ffffff;
}
</style>
